// Module
var code = "<fm-input name=\"{{ ::DateField.name }}\" type=\"text\" placeholder=\"{{ ::DateField.placeholder }}\" config=\"DateField.config\"> <span ng-transclude></span> </fm-input> <fm-errors for=\"{{ ::DateField.name }}\"></fm-errors> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/forms/formation/dateField/dateField.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;